import { accountSelectedSelector } from 'atoms';
import { useRecoilValue } from 'recoil';
import { Account } from 'types/Account';

function RequirePermission({
  children,
  validatePermission,
  fallbackOnInvalid,
}: {
  children: JSX.Element;
  validatePermission: (account: Account | null) => boolean;
  fallbackOnInvalid?: JSX.Element;
}) {
  const accountSelected = useRecoilValue(accountSelectedSelector);

  if (validatePermission(accountSelected)) {
    return children;
  }

  return fallbackOnInvalid || null;
}

export default RequirePermission;
